import { FullScreenLayoutWrapper } from "./FullScreenLayout.style";

import { ReactNode } from "react";

interface FullScreenLayoutProps {
  children: ReactNode;
  open?: boolean;
}

const FullScreenLayout = ({ children, open = true }: FullScreenLayoutProps) => {
  return (
    <FullScreenLayoutWrapper fullScreen open={open} hideBackdrop>
      {children}
    </FullScreenLayoutWrapper>
  );
};

export default FullScreenLayout;
